export default "__VITE_ASSET__DIIvpi5t__"